import Card from "components/card";
import { Icon } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const WidgetMulti = ({
  driver_count,
  title,
  icon,
  this_month,
  last_month,
  all_time,
  change,
}) => {
  // const { this_month, last_month, all_time, change } = number;
const {t}=useTranslation()
  return (
    <Card extra="!flex-col flex-grow justify-between items-center rounded-[20px] p-10">
      {/* Title Section */}
      <div className="mb-4 flex w-full flex-col justify-center">
        <h5 className="font-dm text-lg font-medium text-gray-600">{title}</h5>
      </div>

      {/* Driver Data Section */}
      <div className="flex w-full flex-col space-y-4">
        <div className="flex justify-between">
          <span className="text-gray-500">{t("This Month")}</span>
          <span className="font-bold text-navy-700">
            {Number(this_month).toFixed(2) || 0}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500"> {t("Last Month")}</span>
          <span className="font-bold text-navy-700">
            {Number(last_month).toFixed(2) || 0}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">{t("All Time")}</span>
          <span className="font-bold text-navy-700">
            {Number(all_time).toFixed(2) || 0}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">{t("Change")}</span>
          <span
            className={`font-bold ${
              change >= 0 ? "text-green-500" : "text-red-500"
            }`}
          >
            {Number(change).toFixed(2) || 0}%
          </span>
        </div>
      </div>

      {/* Icon Section */}
      {/* <div className="flex w-full justify-center mt-6">
        <Icon className="text-4xl" component={icon} />
      </div> */}
    </Card>
  );
};

export default WidgetMulti;
